const toFiniteNumber = (value) => {
  const parsedValue =
    typeof value === "string" ? Number(String(value).trim()) : Number(value);
  return Number.isFinite(parsedValue) ? parsedValue : null;
};

export const normalizeAudPriceForDisplay = (rawValue) => {
  const numericValue = toFiniteNumber(rawValue);
  if (numericValue === null) return null;

  if (Number.isInteger(numericValue) && numericValue >= 1000) {
    return numericValue / 100;
  }

  return numericValue;
};

export const normalizeAudPriceToMinorUnits = (rawValue) => {
  const numericValue = toFiniteNumber(rawValue);
  if (numericValue === null) return null;

  if (Number.isInteger(numericValue) && numericValue >= 1000) {
    return numericValue;
  }

  return Math.round(numericValue * 100);
};

export const formatAudAmount = (
  rawValue,
  { minimumFractionDigits, maximumFractionDigits } = {}
) => {
  const displayValue = normalizeAudPriceForDisplay(rawValue);
  if (displayValue === null) return "AUD amount unavailable";

  const hasDecimals = Math.abs(displayValue % 1) > 0;
  const formatter = new Intl.NumberFormat("en-AU", {
    minimumFractionDigits:
      typeof minimumFractionDigits === "number"
        ? minimumFractionDigits
        : hasDecimals
          ? 2
          : 0,
    maximumFractionDigits:
      typeof maximumFractionDigits === "number"
        ? maximumFractionDigits
        : hasDecimals
          ? 2
          : 0,
  });

  return `AUD ${formatter.format(displayValue)}`;
};
